import { __assign } from "tslib";
export var STREAM__DELETE_ITEMS = 'STREAM__DELETE_ITEMS';
export var STREAM__MOVE_ITEM = 'STREAM__MOVE_ITEM';
export var STREAM__REPLACE_ITEM = 'STREAM__REPLACE_ITEM';
export var STREAM__FETCH_FAILURE = 'STREAM__FETCH_FAILURE';
export var STREAM__DELETE_STREAM = 'STREAM__DELETE_STREAM';
export var STREAM__SET_PARAM = 'STREAM__SET_PARAM';
export var STREAM__INSERT_ITEMS = 'STREAM__INSERT_ITEMS';
import { createAction } from 'redux-actions';
export var initializeIfNeeded = createAction('STREAM__INIT_IF_NEEDED', function (streamId, config) { return (__assign({ streamId: streamId }, config)); });
export var fetchNext = createAction('STREAM__FETCH_NEXT', function (streamId) { return ({ streamId: streamId }); });
export var fetchAll = createAction('STREAM__FETCH_ALL', function (streamId) { return ({ streamId: streamId }); });
export var fetchPrevious = createAction('STREAM__FETCH_PREVIOUS', function (streamId) { return ({ streamId: streamId }); });
export function fetch(streamId, direction) {
    switch (direction) {
        case 'prev':
            return fetchPrevious(streamId);
        case 'all':
            return fetchAll(streamId);
        case 'next':
        default:
            return fetchNext(streamId);
    }
}
export var deleteItem = function (_a) {
    var streamId = _a.streamId, item = _a.item, doNotUpdateNextOffset = _a.doNotUpdateNextOffset, isEqual = _a.isEqual;
    return deleteItems({ streamId: streamId, items: [item], doNotUpdateNextOffset: doNotUpdateNextOffset, isEqual: isEqual });
};
export var deleteItems = function (_a) {
    var streamId = _a.streamId, items = _a.items, doNotUpdateNextOffset = _a.doNotUpdateNextOffset, isEqual = _a.isEqual;
    return ({
        type: STREAM__DELETE_ITEMS,
        streamId: streamId,
        items: items,
        doNotUpdateNextOffset: doNotUpdateNextOffset,
        isEqual: isEqual,
    });
};
export var moveItem = function (_a) {
    var streamId = _a.streamId, item = _a.item, position = _a.position;
    return ({
        type: STREAM__MOVE_ITEM,
        streamId: streamId,
        item: item,
        position: position,
    });
};
export var fetchFailure = function (_a) {
    var streamId = _a.streamId, errorMsg = _a.errorMsg;
    return ({
        type: STREAM__FETCH_FAILURE,
        streamId: streamId,
        errorMsg: errorMsg,
    });
};
export var deleteStream = function (streamId) { return ({
    type: STREAM__DELETE_STREAM,
    streamId: streamId,
}); };
export var replaceItem = function (_a) {
    var streamId = _a.streamId, newItem = _a.newItem, predicate = _a.predicate;
    return ({
        type: STREAM__REPLACE_ITEM,
        streamId: streamId,
        newItem: newItem,
        predicate: predicate,
    });
};
export var insertItemsAtOffsets = function (_a) {
    var streamId = _a.streamId, newItems = _a.newItems, deduplicate = _a.deduplicate, doNotUpdateNextOffset = _a.doNotUpdateNextOffset;
    return ({
        type: STREAM__INSERT_ITEMS,
        streamId: streamId,
        newItems: newItems,
        deduplicate: deduplicate,
        doNotUpdateNextOffset: doNotUpdateNextOffset,
    });
};
export var setParam = function (_a) {
    var streamId = _a.streamId, paramType = _a.paramType, paramValue = _a.paramValue;
    return ({
        type: STREAM__SET_PARAM,
        streamId: streamId,
        paramType: paramType,
        paramValue: paramValue,
    });
};
export var replaceItems = createAction('STREAM__REPLACE_ITEMS', function (streamId, updatedItems) { return ({
    streamId: streamId,
    updatedItems: updatedItems,
}); });
// use when you need to mark a stream for fetchinng without actually dispatching the fetch action
// eg. in storybook or some odd saga edge cases
export var markAsFetching = createAction("STREAM__MARK_AS_FETCHING", function (streamId) { return ({ streamId: streamId }); });
export var markAsCancelled = createAction("STREAM__MARK_AS_CANCELLED", function (streamId) { return ({ streamId: streamId }); });
export var cancelFetchForStream = createAction("STREAM__CANCEL_FETCH", function (streamId) { return ({ streamId: streamId }); });
//# sourceMappingURL=actions.js.map